export default {
    fountains: {
        'ανυψωτικό': 'συντριβάνι',
        'ανυψωτικά': 'συντριβάνια',
        'ανυψωτικών': 'συντριβανιών',
        'ανυψωτικού': 'συντριβανιού',
    },
    aircon:{
        'ανυψωτικό': 'κλιματιστικό',
        'ανυψωτικά': 'κλιματιστικά',
        'ανυψωτικών': 'κλιματιστικών',
        'ανυψωτικού': 'κλιματιστικού',
    }
}